<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part-number---IVP" id="_idParaDest-4" title="Part I. The Struggle"><a id="_idTextAnchor007"></a>Part I</h1>
<h2 class="part-title---IVP sigil_not_in_toc">The Struggle</h2>
<p class="dingbat"><img alt="" src="Images/dingbat_c.png"/></p>
<p class="body"><span epub:type="pagebreak" id="page6" title="6"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_part1.vue?52b159d8